import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://fmszkpimrvgdjcuzqpvy.supabase.co';

// Access environment variables securely in Vite using import.meta.env
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZtc3prcGltcnZnZGpjdXpxcHZ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3OTE0ODEsImV4cCI6MjA4MDM2NzQ4MX0.xMXIbQDz6lAE7gsG4dqERj4CZPjj2yFK-HNMKcdJDQw";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export async function signInWithEmail(email: string) {
  const { data, error } = await supabase.auth.signInWithOtp({ email });
  return { data, error };
}

export async function signUpWithPassword(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
            emailRedirectTo: window.location.href,
        }
    });
    return { data, error };
}

export async function signInWithPassword(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
    });
    return { data, error };
}

export async function resendVerification(email: string) {
    const { data, error } = await supabase.auth.resend({
        type: 'signup',
        email,
        options: {
            emailRedirectTo: window.location.href,
        }
    });
    return { data, error };
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  return { error };
}